import React, { useEffect, useState } from 'react';

import Select from 'react-select';

export default function LocaleDropdown(props) {
    const [locales, setLocales] = useState([]);

    useEffect(() => {
        const url = '/api/common/locales';

        axios.get(url).then(({ data }) => {
            setLocales(data.map((item) => ({ label: item.name, value: item.code })));
        });
    }, []);

    return <Select options={locales} isClearable isSearchable classNamePrefix="select" {...props} />;
}
